import { render, staticRenderFns } from "./BaseDistributionBarChart.vue?vue&type=template&id=ce90b4be"
import script from "./BaseDistributionBarChart.vue?vue&type=script&lang=js"
export * from "./BaseDistributionBarChart.vue?vue&type=script&lang=js"
import style0 from "./BaseDistributionBarChart.vue?vue&type=style&index=0&id=ce90b4be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports